import type { ReactNode } from 'react';
import { Link } from '../components/nav';
import { useAppData } from '../state/AppData';

export function Placeholder({ title, children }: { title: string; children: ReactNode }) {
  const { index } = useAppData();
  return (
    <div className="page">
      <h1>{title}</h1>
      {children}
      <p><Link to={`/leer/${index.chapters[0].chapterId}`}>Empezar a leer</Link> · <Link to="/explorar">Explorar el mapa</Link></p>
    </div>
  );
}
